import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useMerchant } from '@dashboard/hooks/useMerchant';

export const CRYPTO_SETUP_PATH = '/dashboard/crypto/wallet';

export default function CryptoLockGuard() {
  const { solanaWalletAddress, merchantLoaded } = useMerchant();
  const location = useLocation();

  if (!merchantLoaded) {
    return (
      <div className="p-6">
        <p className="font-sans text-sm" style={{ color: 'var(--dash-text-muted)' }}>
          Loading...
        </p>
      </div>
    );
  }

  const locked = !solanaWalletAddress;
  const isSetupRoute = location.pathname === CRYPTO_SETUP_PATH;

  if (locked && !isSetupRoute) {
    return <Navigate to={CRYPTO_SETUP_PATH} replace />;
  }

  return <Outlet />;
}
